import backend, {CLIENT_LEAD_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createClientLead = (input) => {
  const url = `${CLIENT_LEAD_API}/client_lead`;
  return backend.post(url, input);
};

const getClientLead = (clientleadRn, loadLatestAnnouncementMessage) => {
  const queryParam = {
    loadLatestAnnouncementMessage,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}?${query}`;
  return backend.get(url);
};

const queryClientLead = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${CLIENT_LEAD_API}/client_lead?${query}`;
  return backend.get(url);
};

const updateDescription = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/description`;
  return backend.put(url, body);
};

const updateFile = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/profile_image`;
  return backend.put(url, body);
};

const updateStatus = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/status`;
  return backend.put(url, body);
};

const updateName = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/name`;
  return backend.put(url, body);
};

const addContact = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/contact`;
  return backend.post(url, body);
};

const removeContact = (clientleadRn, body) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/detail/contact`;
  return backend.delete(url, body);
};

const createMessage = (clientleadRn, input) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message`;
  return backend.post(url, input);
};

const updateMessage = (clientleadRn, messageRn, input) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message/${messageRn}`;
  return backend.put(url, input);
};

const addEmoji = (clientleadRn, messageRn, input) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message/${messageRn}/emoji`;
  return backend.put(url, input);
};

const removeEmoji = (clientleadRn, messageRn, input) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message/${messageRn}/emoji`;
  return backend.delete(url, input);
};

const removeMessage = (clientleadRn, messageRn) => {
  const url = `${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message/${messageRn}`;
  return backend.delete(url);
};

const loadMoreMessages = (clientleadRn, lastKey, loadSubmittedByData, loadEmojiRequesters) => {
  const queryParam = {
    lastEvaluatedKey: lastKey,
    loadSubmittedByData,
    loadEmojiRequesters,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_LEAD_API}/client_lead/${clientleadRn}/message?${query}`);
};

const loadLogs = (clientleadRn, lastEvaluatedKey, loadRequesterData) => {
  const queryParam = {
    lastEvaluatedKey,
    loadRequesterData,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_LEAD_API}/client_lead/${clientleadRn}/log?${query}`);
};

export default {
  createClientLead,
  getClientLead,
  queryClientLead,

  updateDescription,
  updateStatus,
  updateFile,
  updateName,
  addContact,
  removeContact,

  message: {
    create: createMessage,
    update: updateMessage,
    delete: removeMessage,
    load: loadMoreMessages,

    emoji: {
      add: addEmoji,
      remove: removeEmoji,
    },
  },

  loadLogs,
};
